module.exports = __webpack_public_path__ + "static/media/21_Club_house_Secor_A_new.6082a0d6.jpg";